<template>
    <div class="calendar container-fluid">
        <div class="row">
            <Menu title="Calendar" />
            <div class="col-12 p-0"> 
                <Calendar id="calendar_view"></Calendar>
            </div>
        </div>
    </div>
</template>

<style scoped>
    #calendar_view{
        position: relative;
        top:55px;
    }
</style>

<script>
    import Menu from '@/components/menu_component.vue';
    import Calendar from '@/components/Calendar_component.vue';

    export default {
        name: 'calendar',
        data() {
            return {
                'check': 'hello'
            }
        },
        components: {
            Menu,
            Calendar
        }
    }
</script>